<template>
	<div>
		<div class="xs-12 fs4 fw7 mt6 mb2">
			自您签署信息披露和授权之日起较早的日期，机密医疗问卷和/或健康史问卷：
		</div>
		<case-form :schema="schema" class="mt6" />
		<case-form :schema="schemaTravel" class="mt6 mb6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			提供您过去14天的旅行记录：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">旅游模式</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelPast14Days(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<div class="fs4 fw7 lh125 mt6 mb2">
			提供接下来30天的旅行记录：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">旅游模式</span>
				{{ i }}
			</div>
			<div slot="body" class="p6 bg5">
				<case-form :schema="schemaTravelNext30Days(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemaSmoking" class="mt6" />
		<div class="xs-12 fs4 fw7 mt6 mb2">香烟</div>
		<case-form :schema="schemaCigarettes" />
		<case-form :schema="schemaFinancial" class="mt6" />
		<case-form :schema="schemaAviation" class="mt6" />
		<case-form :schema="schemaHazardousActivities" class="mt6" />
		<case-form :schema="schemaInsurance" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schema() {
			return [
				{
					label: `您是否有过对COVID-19测试阳性？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasTestedPostiveForCovid19CN`,
					props: {
						suggest: {
							typeIncludes: `hasTestedPostiveForCovid19CN`
						},
						createOptions: {
							type: `hasTestedPostiveForCovid19CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去30天内，您是否因COVID-19而被建议自我隔离或留在家中（不包括必须留在家里的强制性政府命令）？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasBeenAdvisedToIsolateDueToCovid19CN`,
					props: {
						suggest: {
							typeIncludes: `hasBeenAdvisedToIsolateDueToCovid19CN`
						},
						createOptions: {
							type: `hasBeenAdvisedToIsolateDueToCovid19CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去的30天内，您有任何与covid19相关的症状吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasCovid19SymptomsInLast30DaysCN`,
					props: {
						suggest: {
							typeIncludes: `hasCovid19SymptomsInLast30DaysCN`
						},
						createOptions: {
							type: `hasCovid19SymptomsInLast30DaysCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去30天内，您是否与怀疑或确认患有COVID-19的个人进行了接触？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasContactWithCovid19PatientInLast30DaysCN`,
					props: {
						suggest: {
							typeIncludes: `hasContactWithCovid19PatientInLast30DaysCN`
						},
						createOptions: {
							type: `hasContactWithCovid19PatientInLast30DaysCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `如果以上任何一项是"是"，您是否已完全康复并恢复了正常活动？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasRecoveredFromCovid19CN`,
					props: {
						suggest: {
							typeIncludes: `hasRecoveredFromCovid19CN`
						},
						createOptions: {
							type: `hasRecoveredFromCovid19CN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您是否接受过医生或其他执业医师的检查或治疗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasBeenTreatedByPhysicianOrPractitionerCN`,
					props: {
						suggest: {
							typeIncludes: `hasBeenTreatedByPhysicianOrPractitionerCN`
						},
						createOptions: {
							type: `hasBeenTreatedByPhysicianOrPractitionerCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您是否进行过心电图检查，X射线检查或其他诊断检查？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasDiagnosticTestCN`,
					props: {
						suggest: {
							typeIncludes: `hasDiagnosticTestCN`
						},
						createOptions: {
							type: `hasDiagnosticTestCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您是否使用过大麻，可卡因或除医生处方之外的任何其他药物？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasUsedDrugsWithoutPrescriptionCN`,
					props: {
						suggest: {
							typeIncludes: `hasUsedDrugsWithoutPrescriptionCN`
						},
						createOptions: {
							type: `hasUsedDrugsWithoutPrescriptionCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您是否因酗酒或吸毒得到过治疗或咨询？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasTreatedOrCounseledForAlcoholismOrDrugAbuseCN`,
					props: {
						suggest: {
							typeIncludes: `hasTreatedOrCounseledForAlcoholismOrDrugAbuseCN`
						},
						createOptions: {
							type: `hasTreatedOrCounseledForAlcoholismOrDrugAbuseCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您是否已由合格的医师诊断或治疗后天免疫机能丧失综合症（AIDS），AIDS相关综合症（ARC）或免疫系统的任何其他疾病？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasImmuneSystemDisorderCN`,
					props: {
						suggest: {
							typeIncludes: `hasImmuneSystemDisorderCN`
						},
						createOptions: {
							type: `hasImmuneSystemDisorderCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您是否知道尚未就医或尚未接受治疗的任何有关您的健康的症状或不适？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasUnconsultedSymptomsCN`,
					props: {
						suggest: {
							typeIncludes: `hasUnconsultedSymptomsCN`
						},
						createOptions: {
							type: `hasUnconsultedSymptomsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `除了已经披露的情况外，是否有医生建议您完成但尚未完成的任何检查或转诊, 或者您目前正在等待检查结果？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-isWaitingForTestResultCN`,
					props: {
						suggest: {
							typeIncludes: `isWaitingForTestResultCN`
						},
						createOptions: {
							type: `isWaitingForTestResultCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label:
						"对于上述所有肯定的答案，请提供完整的详细信息。详细信息应包括日期，症状发作的日期，诊断，持续时间，主治医生的姓名和地址以及医疗设施：",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-supplementalInformationMedicalHistoryAdditionalDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `supplementalInformationMedicalHistoryAdditionalDetailsCN`
						},
						createOptions: {
							type: `supplementalInformationMedicalHistoryAdditionalDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaTravel() {
			return [
				{
					label: `您过去14天有旅行吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasTravelledPast14DaysCN`,
					props: {
						suggest: {
							typeIncludes: `hasTravelledPast14DaysCN`
						},
						createOptions: {
							type: `hasTravelledPast14DaysCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `您未来30天有旅行吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-willTravelInNext30DaysCN`,
					props: {
						suggest: {
							typeIncludes: `willTravelInNext30DaysCN`
						},
						createOptions: {
							type: `willTravelInNext30DaysCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaFinancial() {
			return [
				{
					label: "您的工作或财务状况是否发生了变化？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasWorkOrFinancialStatusChangedCN`,
					props: {
						suggest: {
							typeIncludes: `hasWorkOrFinancialStatusChangedCN`
						},
						createOptions: {
							type: `hasWorkOrFinancialStatusChangedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请说明",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-workOrFinancialStatusChangeDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `workOrFinancialStatusChangeDetailsCN`
						},
						createOptions: {
							type: `workOrFinancialStatusChangeDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaAviation() {
			return [
				{
					label:
						"您参加航空活动（除了作为定期商业航空公司的旅客以外）的参与方式是否发生了变化？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasAviationActivityChangedCN`,
					props: {
						suggest: {
							typeIncludes: `hasAviationActivityChangedCN`
						},
						createOptions: {
							type: `hasAviationActivityChangedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请说明",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-aviationActivityChangeDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `aviationActivityChangeDetailsCN`
						},
						createOptions: {
							type: `aviationActivityChangeDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaHazardousActivities() {
			return [
				{
					label: "您参加的任何业余爱好（危险的体育活动）是否有所改变？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasAvocationParticipationChangedCN`,
					props: {
						suggest: {
							typeIncludes: `hasAvocationParticipationChangedCN`
						},
						createOptions: {
							type: `hasAvocationParticipationChangedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请说明",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-avocationParticipationChangeDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `avocationParticipationChangeDetailsCN`
						},
						createOptions: {
							type: `avocationParticipationChangeDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaInsurance() {
			return [
				{
					label:
						"是否已根据特殊条款拒绝或接受任何人寿或健康保险的申请或恢复申请？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasInsuranceApplicationRejectedUnderSpecialTermsCN`,
					props: {
						suggest: {
							typeIncludes: `hasInsuranceApplicationRejectedUnderSpecialTermsCN`
						},
						createOptions: {
							type: `hasInsuranceApplicationRejectedUnderSpecialTermsCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请说明公司名称和原因：",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-insuranceApplicationRejectedDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `insuranceApplicationRejectedDetailsCN`
						},
						createOptions: {
							type: `insuranceApplicationRejectedDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"自填写“信息披露和授权”表格以来，您的人寿保险有效承保范围是否已更改？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasLifeInsuranceInForceChangedCN`,
					props: {
						suggest: {
							typeIncludes: `hasLifeInsuranceInForceChangedCN`
						},
						createOptions: {
							type: `hasLifeInsuranceInForceChangedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请说明",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-lifeInsuranceInForceChangeDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `lifeInsuranceInForceChangeDetailsCN`
						},
						createOptions: {
							type: `lifeInsuranceInForceChangeDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "您是否正在与其他承运人一起申请人寿保险？",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-hasPendingApplicationWithOtherCarriersCN`,
					props: {
						suggest: {
							typeIncludes: `hasPendingApplicationWithOtherCarriersCN`
						},
						createOptions: {
							type: `hasPendingApplicationWithOtherCarriersCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "如果是，请提供详细信息，包括申请的总金额：",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-pendingApplicationDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `pendingApplicationDetailsCN`
						},
						createOptions: {
							type: `pendingApplicationDetailsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "附加信息",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-additionalInformationCN`,
					props: {
						suggest: {
							typeIncludes: `additionalInformationCN`
						},
						createOptions: {
							type: `additionalInformationCN`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaSmoking() {
			return [
				{
					label:
						"您曾否吸食任何形式的烟草或尼古丁产品（包括香烟、雪茄、小雪茄、烟斗、嚼烟、尼古丁贴片 或尼古丁香口糖）?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-useTobaccoOrNicotineProductCN`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProductCN`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProductCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaCigarettes() {
			return [
				{
					label: `产品`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteProductUsedCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteProductUsedCN`
						},
						createOptions: {
							type: `cigaretteProductUsedCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `每天数量（香烟）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteNumberPerDayCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteNumberPerDayCN`
						},
						createOptions: {
							type: `cigaretteNumberPerDayCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `缩写`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteInitialsCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteInitialsCN`
						},
						createOptions: {
							type: `cigaretteInitialsCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `您以前使用过烟草产品，但现在已经停止使用了吗？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-smokeCigaretteInPastCN`,
					props: {
						suggest: {
							typeIncludes: `smokeCigaretteInPastCN`
						},
						createOptions: {
							type: `smokeCigaretteInPastCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `上次使用日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-cigaretteDateStoppedUseCN`,
					props: {
						suggest: {
							typeIncludes: `cigaretteDateStoppedUseCN`
						},
						createOptions: {
							type: `cigaretteDateStoppedUseCN`,
							dataType: "date"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaTravelPast14Days(i) {
			return [
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCountry${i}CN`
						},
						createOptions: {
							type: `past14DaysCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysCity${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysCity${i}CN`
						},
						createOptions: {
							type: `past14DaysCity${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `入境日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysArrivalDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysArrivalDate${i}CN`
						},
						createOptions: {
							type: `past14DaysArrivalDate${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `离境日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-past14DaysDepartureDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `past14DaysDepartureDate${i}CN`
						},
						createOptions: {
							type: `past14DaysDepartureDate${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		},

		schemaTravelNext30Days(i) {
			return [
				{
					label: `国家`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysCountry${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next30DaysCountry${i}CN`
						},
						createOptions: {
							type: `next30DaysCountry${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `城市`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysCity${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next30DaysCity${i}CN`
						},
						createOptions: {
							type: `next30DaysCity${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `入境日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysArrivalDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next30DaysArrivalDate${i}CN`
						},
						createOptions: {
							type: `next30DaysArrivalDate${i}CN`,
							dataType: "date"
						}
					}
				},
				{
					label: `离境日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0supplemental-next30DaysDepartureDate${i}CN`,
					props: {
						suggest: {
							typeIncludes: `next30DaysDepartureDate${i}CN`
						},
						createOptions: {
							type: `next30DaysDepartureDate${i}CN`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
